import { Component, OnInit } from '@angular/core';
import { SurveyQuestionVm } from '../models/surveyquestionVm';
import { SurveyService } from '../services/survey.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-exemption-secondary-review-request',
  templateUrl: './exemption-secondary-review-request.component.html',
  styleUrls: ['./exemption-secondary-review-request.component.css']
})
export class ExemptionsecondaryReviewRequestComponent implements OnInit {

  questions: SurveyQuestionVm[];
  constructor(private surveyServiceProxy: SurveyService,) { }

  env: string;
  async ngOnInit() {
    this.env = environment.headerBanner;
    // this.stateService.hideHeaderSideBar();
    this.questions = await this.surveyServiceProxy.GetExceptionSecondaryRevReqFormQuestions().toPromise();
    console.log(this.questions);
  }

}
